import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import store from './Stores/SurveyStore'
import ibsStore from './Stores/IbsSurveyStore'
import sharedStore from './Stores/SharedStore'
import { SurveyTypeURL } from "../Enums/constants";
import numeral from "numeral";
import packageJson from '../../package.json'

import { morningstarMatch } from '../Services/IBS/IbsService'
import { validateSurveyCrtl, secretValidateCtrl, secretRulesRefreshCtrl, clearErrorsCtrl } from "../control"
import { GetMandateDefaultsList } from "../Helpers/DefaultsHelper";

// For Investment Surveys only: No pabs support yet.
// developerMode flag set and read in SurveyStore instead of SharedStore as other NavMenu flags are set there.
// Entries added in format:<span style={{ color: "yellow" }}></span> <span style={{ color: "green" }}></span><br />
const DeveloperWindow = observer(() => {

    const [expanded, setExpanded] = useState(false);
    const [errors1, setErrors1] = useState([]);
    const [errors2, setErrors2] = useState([]);

    const infoColor = "lightgreen";
    const nameColor = "yellow";

    const devWindowSetShop = () => {
        let v = document.getElementById("varDevWindow").value;
        let p = document.getElementById("propDevWindow").value;

        if (typeof ibsStore?.currentSurvey === "undefined" || ibsStore.currentSurvey === null) { return;}
        if (p === "" || p?.toString()?.length <= 0) { return; }

        try {
            let setFlag = false;
            if (v === "undefined") {
                let a;
                ibsStore.currentSurvey[p] = a;
                setFlag = true;
                console.error(ibsStore.currentSurvey[p]);
            }
            if (v === "null") {
                ibsStore.currentSurvey[p] = null;
                setFlag = true;
                console.error(ibsStore.currentSurvey[p]);
            }
            if (!isNaN(Number(v)) && Number(v).toString().length === v.toString().length) {
                ibsStore.currentSurvey[p] = Number(v);
                setFlag = true;
            }
            if (!setFlag) {
                ibsStore.currentSurvey[p] = v.toString();
            }
            console.error("Set Value Success!")
        }
        catch { console.error("Set Value Failure"); }
    };

    const diffCacheErrors = () => {
        if (errors1 == null || errors2 == null) {
            console.error("One error cache is not defined.");
            return;
        }

        let errorDiff = [];
        console.error("Errors1 length: " + errors1.length.toString());
        console.error("Errors2 length: " + errors2.length.toString());

        console.error("Errors1: " + JSON.stringify(errors1));
        console.error("Errors2: " + JSON.stringify(errors2));

        // This was causing a lot of trouble, I think the array forming might be odd
        for (let i = 0; i < errors1.length; i++) {
            let check = false;
            for (let j = 0; j < errors2.length; j++) {
                let error1 = errors1[i];
                let error2 = errors2[j];
                if (error1?.ErrorId == error2?.ErrorId) {
                    check = true;
                }
            }
            if (check === false) {
                errorDiff.push(errors1[i]);
            }
        }

        console.error("ErrorsDiff length: " + errorDiff.length.toString());
        console.error(JSON.stringify(errorDiff));
    }

    const pullMorningstarData = () => {
        if (typeof ibsStore?.currentSurvey?.SurveyID === "undefined" || ibsStore.currentSurvey?.SurveyID === null) {
            alert("Please load a Survey")
            return;
        }
        morningstarMatch(ibsStore?.currentSurvey?.SurveyID);
    }

    let pullMsDataUiElement = null;
    if (store.surveyTypeUrl == SurveyTypeURL.DC) {
        pullMsDataUiElement = <React.Fragment>

        </React.Fragment>
    }

    let DevWindowPABS = 
    <React.Fragment>
        {(store.developerMode) &&
            <div className="developerWindow">
                <div>
                    <span style={{ marginBottom: "10px" }}> Developer Info: </span><button className="DevWindowButton" id="DevWindowButton2" onClick={() => { setExpanded(!expanded) }}><span>{expanded ? "-" : "+"}</span></button><br />
                </div>
                <div style={{ display: "inline-block" }}>
                    <div className="devLeft">
                        <span style={{ color: nameColor }} title="SurveyID">Surveys Version: </span> <span style={{ color: infoColor }}> {packageJson?.version} </span><br />
                            <span style={{ color: nameColor }} title="SurveyID">Config Profile: </span> <span style={{ color: infoColor }}> {process.env.REACT_APP_IDENTITY} </span><br />
                            <div className="devPaddingDiv"></div>
                            <span style={{ color: nameColor, cursor: "pointer" }} title="SurveyID" onClick={() => { console.error(JSON.stringify(store?.currentSurvey ?? {})); }}>Survey ID: </span>
                                <span style={{ color: infoColor }}> {store?.currentSurvey?.SurveyId} </span><br />
                            <span style={{ color: nameColor }} title="OrgName">Org Name: </span> <span style={{ color: infoColor }}> {store?.currentSurvey?.OrgName} </span><br />
                            <span style={{ color: nameColor }} title="OrgNameId">Org Name ID: </span> <span style={{ color: infoColor }}> {store?.currentSurvey?.OrgNameId} </span><br />
                            <span style={{ color: nameColor }} title="Country">Country: </span> <span style={{ color: infoColor }}> {store?.currentSurvey?.CountryName} </span><br />
                            <span style={{ color: nameColor }} title="SurveyTypeId">Survey Type ID: </span> <span style={{ color: infoColor }}> {store?.currentSurvey?.SurveyTypeId} </span><br />
                        
                    </div>
                    <div className="devRight">

                    </div>
                </div>
            </div>
        }
    </ React.Fragment>;
    let DevWindowIBS =
    <React.Fragment>
        {(store.developerMode) &&
            <div className="developerWindow">
                <div>
                <span style={{ marginBottom: "10px" }}> Developer Info: </span><button className="DevWindowButton" id="DevWindowButton2" onClick={() => { setExpanded(!expanded) }}><span>{expanded ? "-" : "+"}</span></button><br />
                </div>
                <div style={{ display: "inline-block" }}>
                <div className="devLeft">
                    <span style={{ color: nameColor }} title="SurveyID">Surveys Version: </span> <span style={{ color: infoColor }}> {packageJson?.version} </span><br />
                    <span style={{ color: nameColor }} title="SurveyID">Config Profile: </span> <span style={{ color: infoColor }}> {process.env.REACT_APP_IDENTITY} </span><br />
                    <div className="devPaddingDiv"></div>
                    <span style={{ color: nameColor }} title="SurveyID">Survey ID: </span> <span style={{ color: infoColor }}> {ibsStore?.currentSurvey?.SurveyID} </span><br />
                    <span style={{ color: nameColor }} title="SurveyStatusID">Survey Status ID: </span><span style={{ color: infoColor }}>{ibsStore?.currentSurvey?.SurveyStatusID}</span><br />
                    <span style={{ color: nameColor }} title="DataYear">Data Year: </span> <span style={{ color: infoColor }}> {ibsStore?.currentSurvey?.DataYear} </span><br />
                    {expanded && <><span style={{ color: nameColor }}>Current Data Year: </span> <span style={{ color: infoColor }}> {sharedStore?.currentDataYear} </span><br /></>}
                    {expanded && <> <span style={{ color: nameColor }}>Current Survey Year: </span> <span style={{ color: infoColor }}> {store?.currentYear} </span><br /></>}
                    <span style={{ color: nameColor }} title="CountryID">Country ID: </span><span style={{ color: infoColor }}>{ibsStore?.currentSurvey?.CountryID}</span><br />
                    {expanded && <><span style={{ color: nameColor }} title="PlanSponsor">Plan Sponsor: </span> <span style={{ color: infoColor }}> {ibsStore?.currentSurvey?.PlanSponsor} </span><br /></>}
                    {expanded && <><span style={{ color: nameColor }} title="Plan">Plan Name: </span><span style={{ color: infoColor }}>{ibsStore?.currentSurvey?.Plan}</span><br /></>}
                    {expanded && <><span style={{ color: nameColor }} title="PlanID">Plan ID: </span> <span style={{ color: infoColor }}> {ibsStore?.currentSurvey?.PlanID} </span><br /></>}
                    {expanded && <><span style={{ color: nameColor }} title="ProductID">Product ID: </span><span style={{ color: infoColor }}>{ibsStore?.currentSurvey?.ProductID}</span><br /></>}
                    <span style={{ color: nameColor }} title="EnhancedInternalID">Enhanced ID: </span><span style={{ color: infoColor }}>{ibsStore?.currentSurvey?.EnhancedInternalID}</span><br />
                    <span style={{ color: nameColor }} title="PartnershipID">Partnership ID: </span><span style={{ color: infoColor }}>{ibsStore?.currentSurvey?.PartnershipID}</span><br />
                    <span style={{ color: nameColor }}>Mandate Level: </span><span style={{ color: infoColor }}>{ibsStore?.checkMandateLevel}</span><br />
                    {expanded && <><span style={{ color: nameColor }} title="ReturnMonth">Return Month: </span><span style={{ color: infoColor }}>{ibsStore?.currentSurvey?.ReturnMonth}</span><br /></>}
                    {expanded && <><span style={{ color: nameColor }} title="IsReadOnly">Is Read Only [PABS]: </span><span style={{ color: infoColor }}>{store?.currentSurvey?.IsReadOnly}</span><br /></>}
                    {expanded && <><span style={{ color: nameColor }} title="IsLocked">Is Locked [IBS]: </span><span style={{ color: infoColor }}>{ibsStore?.surveyListDisplay?.find(survey => survey.SurveyID == ibsStore?.currentSurvey?.SurveyID)?.IsLocked?.toString()}</span><br /></>}
                    </div>
                    <div className="devRight">
                        <span style={{ color: nameColor }}>Page Name: </span>
                        <span style={{ color: infoColor }}>{store?.currentLandedPage}</span><br />
                        <div className="devPaddingDiv"></div>

                        {expanded && <><span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(store.warningSummary); }}> Survey Warning Count: </span>
                            <span style={{ color: infoColor }}>{store?.allWarnings?.length ?? 0}<sup>*</sup></span><br /></>}

                        {expanded && <> <span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(store.errorSummary); }}>Survey Error Count: </span>
                            <span style={{ color: infoColor }}>{store?.errorSummary?.length ?? 0}<sup>*</sup></span><br /></>}
                        {expanded && <> <div className="devPaddingDiv"></div></>}
                        <span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(JSON.stringify(store?.pageWarnings ?? {})); }}>Page Warnings: </span>
                        <span style={{ color: infoColor }}>{store.pageWarningCount ?? 0}</span><br />
                        {expanded && <><span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(JSON.stringify(store?.pageFloatingWarnings ?? {})); }}>Page Floating Warnings: </span>
                            <span style={{ color: infoColor }}>{store?.pageFloatingWarnings?.length ?? 0}</span><br /></>}
                        {expanded && <> <span style={{ color: nameColor }}>Page Cell Warnings: </span>
                            <span style={{ color: infoColor }}>{store.cellWarningCount ?? 0}</span><br /></>}

                        <div className="devPaddingDiv"></div>
                        <span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(JSON.stringify(ibsStore.allTableResponses["combinedAssets"] ?? {})); }}>Page Errors: </span>
                        <span style={{ color: infoColor }}>{store.pageErrorCount ?? 0}</span><br />
                        {expanded && <><span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(JSON.stringify(store?.pageFloatingErrors ?? {})); }}>Page Floating Errors: </span>
                            <span style={{ color: infoColor }}>{store?.pageFloatingErrors?.length ?? 0}</span><br /></>}
                        {expanded && <> <span style={{ color: nameColor }}>Page Cell Errors: </span>
                            <span style={{ color: infoColor }}>{store.cellErrorCount ?? 0}</span><br /></>}
                        <div className="devPaddingDiv"></div>

                        <span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(JSON.stringify(store.surveyTypeUrl === SurveyTypeURL.DB ? GetMandateDefaultsList() : [])); }}>Defaults: </span>
                        <span style={{ color: infoColor }}>{(store.surveyTypeUrl === SurveyTypeURL.DB ? GetMandateDefaultsList() : [])?.length}</span><br />
                        <div className="devPaddingDiv"></div>

                        <span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(JSON.stringify(numeral?.localeData()?.delimiters ?? [])); }}>Decimal Delimiter: </span>
                        <span style={{ color: infoColor }}>{numeral.localeData().delimiters.decimal}</span><br />
                        <span style={{ color: nameColor, cursor: "pointer" }} onClick={() => { console.error(JSON.stringify(numeral?.localeData()?.delimiters ?? [])); }}>Thousands Delimiter: </span>
                        <span style={{ color: infoColor }}>{numeral.localeData().delimiters.thousands}</span><br />

                    </div>
                </div>
                <div><span style={{ color: infoColor, fontSize: "12px", lineHeight: "20%" }}><sup>*</sup>Only appear after validation. Dismissed/Explained errors not included.</span></div>

                <br />
                <div>
                    <span style={{ marginBottom: "10px" }}> Developer Panel: </span>
                </div>
                <div style={{ display: "inline-block" }}>
                <div><span style={{ fontSize: "12px", lineHeight: "20%", whiteSpace: "nowrap", overflow: "hidden" }}>CurrentSurvey Property: <input type="text" className="inputDevWindow" id="propDevWindow"></input> = <input type="text" className="inputDevWindow" id="varDevWindow"></input><button onClick={() => { devWindowSetShop(); }} className="DevWindowButton" id="DevWindowButton1">set</button></span></div>
                <div className="devPaddingDiv"></div>
                    <button className="DevWindowButton" style={{ marginRight: "10px" }} onClick={() => { validateSurveyCrtl(); }}><span>Validate Survey</span></button>
                    <button className="DevWindowButton" style={{ marginRight: "10px" }} onClick={() => { secretRulesRefreshCtrl(); }}><span>Reload Rules</span></button>
                    <button className="DevWindowButton" onClick={() => { secretValidateCtrl(); }}><span>Validate Survey (Secret)</span></button>
                    <div className="devPaddingDiv"></div>
                    <button className="DevWindowButton" style={{ marginRight: "10px" }} onClick={() => { setErrors1(Array.from(store?.pageWarnings)); }}><span>Cache Errors [1]</span></button>
                    <button className="DevWindowButton" style={{ marginRight: "10px" }} onClick={() => { setErrors2(Array.from(store?.pageWarnings)); }}><span>Cache Errors [2]</span></button>
                    <button className="DevWindowButton" onClick={() => { diffCacheErrors(); }}><span>Diff Cache Errors</span></button>
                    <div className="devPaddingDiv"></div>
                    <button disabled={store.surveyTypeUrl != SurveyTypeURL.DC} className="DevWindowButton" style={{ marginRight: "10px" }} onClick={() => { pullMorningstarData(); }}><span>Pull Morningstar Data</span></button>
                    <button disabled={ibsStore?.currentSurvey?.SurveyID == null} className="DevWindowButton" style={{ marginRight: "10px" }} onClick={() => { clearErrorsCtrl(ibsStore?.currentSurvey?.SurveyID); }}><span>Clear All Errors</span></button>

                </div>
            </div>
        }
        </ React.Fragment>

    return (store.surveyTypeUrl !== SurveyTypeURL.DB && store.surveyTypeUrl !== SurveyTypeURL.DC && store.surveyTypeUrl !== SurveyTypeURL.IBS) ? DevWindowPABS : DevWindowIBS;
});

export default DeveloperWindow;